module.exports = __webpack_public_path__ + "media/packs/images/flags/YE-c6ed3b61e95d0c7498133521af7fa057.svg";